<template>
  <div class="content-7__lottery">
    <!-- 彩票資訊 -->
    <div class="content-7__lottery__icon">
      <img class="lottery-img" width="90px" :src="lotteryDetail.iconURL" alt="彩种icon">
    </div>
    <div class="content-7__lottery__content">
      <div class="lotterybox">
        <div class="lotterybox__lottery-name"><span class="lotterybox__lottery-name__text">{{ lotteryDetail.name }}</span></div>
        <div class="lotterybox__lottery-datenumber"><span class="lotterybox__lottery-datenumber__number">{{ headerData.period }}</span><span class="lotterybox__lottery-datenumber__text">期</span></div>
        <div class="lotterybox__lottery-detail">
          <span v-if="lotteryDetail.code === 'smam6'" class="lotterybox__lottery-detail__text">开奖频率: 每小时</span>
          <span v-else-if="lotteryDetail.categoryCode === 'local' || lotteryDetail.categoryCode === 'china'" class="lotterybox__lottery-detail__text">开奖星期: {{ formatWeek(lotteryDetail.weekdays) }}</span>
          <span v-else-if="lotteryDetail.categoryCode === 'gaopin' || lotteryDetail.categoryCode === 'jisu' " class="lotterybox__lottery-detail__text">开奖频率: {{ formatMinute(lotteryDetail.intervalSeconds) }}</span>
          <span v-else-if="lotteryDetail.closeDay" class="lotterybox__lottery-detail__text">休市: {{ formatClose(lotteryDetail.closeDay) }}</span>
        </div>
      </div>
      <div class="lottery-ballbox">
        <div class="ballbox">
          <template v-for="(ball, ballIndex) in headerData.balls">
            <!-- 前六顆 正碼 -->
            <div v-if="ballIndex !== 6" :key="ballIndex" class="ballbox__item">
              <template v-if="!isTimeUP">
                <div class="ball size-large" :class="setBallColor(ball.seBo)">
                  <span class="ball__number">{{ padZero(ball.number) }}</span>
                </div>
                <div class="ballbox__item__detail">
                  <span class="detail-text">{{ ball.shengXiao | formatLot }}</span>
                  <span class="detail-text">/</span>
                  <span class="detail-text red">{{ ball.wuXing | formatLot }}</span>
                </div>
              </template>

              <!-- 開獎中特效 -->
              <template v-else>
                <div class="ball size-large" :class="setBallColor(randomColor[ballIndex])">
                  <span class="ball__number">{{ padZero(randomNum[ballIndex]) }}</span>
                </div>
                <div class="ballbox__item__detail">
                  <span class="detail-text">－</span>
                  <span class="detail-text">/</span>
                  <span class="detail-text red">－</span>
                </div>
              </template>
            </div>
          </template>
          <!-- 加號 -->
          <div class="ballbox__item"><img :src="require('@/assets/style/desktop/img/plus.svg')" alt=""></div>
          <!-- 第七顆 特碼 -->
          <div class="ballbox__item">
            <template v-if="!isTimeUP && headerData.balls[6]">
              <div class="ball size-large" :class="setBallColor(headerData.balls[6].seBo)">
                <span class="ball__number">{{ padZero(headerData.balls[6].number) }}</span>
              </div>
              <div class="ballbox__item__detail">
                <span class="detail-text">{{ headerData.balls[6].shengXiao | formatLot }}</span>
                <span class="detail-text">/</span>
                <span class="detail-text red">{{ headerData.balls[6].wuXing | formatLot }}</span>
              </div>
            </template>

            <!-- 開獎中特效 -->
            <template v-else>
              <div class="ball size-large" :class="setBallColor(randomColor[6])">
                <span class="ball__number">{{ padZero(randomNum[6]) }}</span>
              </div>
              <div class="ballbox__item__detail">
                <span class="detail-text">－</span>
                <span class="detail-text">/</span>
                <span class="detail-text red">－</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 倒數 -->
    <div class="countdown">
      <div class="countdown__title"><span class="countdown__title__text">下期开奖</span></div>
      <CounterDown v-model="isTimeUP" :draw-time="headerData.drawTime" @changeInfo="getCpsDetail(headerData.code)" />
    </div>

    <!-- 日曆 ＆ 说明 -->
    <div class="lottery-title__explanation">
      <el-popover
        v-if="isHK6"
        ref="calendarPopover"
        placement="bottom"
        width="400"
        trigger="manual"
        :value="showCalendar"
        @show="reset=true"
        @hide="reset=false"
      >
        <span slot="reference">
          <div class="date">
            <div ref="calendarBtn" class="button-outline" href="" @click="toggleCalendar">
              <span class="button-outline__text">
                查看开奖日历
              </span>
            </div>
          </div>
        </span>
        <Calendar v-if="reset" />
      </el-popover>
      <a class="button-outline" @click.prevent="showExplain = true">
        <span class="button-outline__text">玩法说明</span>
      </a>
    </div>

    <!-- 开奖视频 -->
    <div class="content-7__videobox">
      <div class="videobox" @click="openVideo">
        <img width="151px" height="90px" :src="require('@/assets/frontend/lhc.png')" alt="">
        <div class="videobox__mask">
          <img class="videobox__mask__img" :src="require('@/assets/style/desktop/img/video-mask.svg')" alt="">
        </div>
      </div>
    </div>

    <VideoDialog :show.sync="showVideo" :lottery-code="setLotteryCode" />
    <ExplainDialog :show.sync="showExplain" />

  </div>
</template>

<script>
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import VideoDialog from '@/components/desktop/common/VideoDialog'
import ExplainDialog from '@/components/desktop/common/ExplainDialog'
import CounterDown from '@/components/desktop/common/CounterDown'
import Calendar from '@/components/desktop/common/calendar/calendar'

const formatSeBo = {
  'yanse_hong': 'color--red',
  'yanse_lyu': 'color--green',
  'yanse_lan': 'color--blue'
}

const SeBoArray = ['yanse_hong', 'yanse_lyu', 'yanse_lan']

const weekMap = ['日', '一', '二', '三', '四', '五', '六']

export default {
  name: 'HeaderDetail',
  filters: {
    formatLot(value) {
      return ruleCodeMapping[value]
    }
  },
  components: {
    VideoDialog,
    CounterDown,
    ExplainDialog,
    Calendar
  },
  props: {
    lotteryCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lotteryName: '六合彩',
      period: '1234567',
      showVideo: false,
      showExplain: false,
      isTimeUP: false,
      isLoading: true,
      randomNum: [0, 0, 0, 0, 0, 0, 0],
      randomColor: ['yanse_hong', 'yanse_lyu', 'yanse_lan', 'yanse_hong', 'yanse_lyu', 'yanse_lan', 'yanse_hong'],
      randomTimer: null,
      reset: false,
      showCalendar: false
    }
  },
  computed: {
    // 彩種基本資料 (頻率, 中文名, 休市日, icon)
    cpsDetail() {
      return this.$store.state.lottery.cpsDetail
    },
    // 對應 route params 更換 cpsDetail 資料
    // 如果沒有 route params 使用 props 的 lotteryCode
    setLotteryCode() {
      return this.$route.params.lottery_code || this.lotteryCode
    },
    lotteryDetail() {
      const cpsDetail = this.$store.state.lottery.cpsDetail
      return cpsDetail[this.setLotteryCode]
    },
    // 對應 route params 更換 cpsList 資料
    headerData() {
      const cpsList = this.$store.state.lottery.cpsList
      if (cpsList.length > 0) {
        const findData = cpsList.find(item => item.code === this.setLotteryCode)
        if (findData) {
          return findData
        }
      }

      return {
        name: '六合彩',
        code: '',
        period: '0000000',
        balls: [],
        tableInfo: {}
      }
    },
    isHK6() {
      return this.setLotteryCode === 'hk6'
    }
  },
  watch: {
    'headerData.period'(newPeriod, oldPeriod) {
      if (oldPeriod && newPeriod !== oldPeriod) {
        console.log(11)
        this.$emit('complete')
      }
    },
    isTimeUP(val) {
      if (val) {
        // 模擬攪珠
        this.randomTimer = setInterval(() => {
          this.randomNum = this.randomNum.map(num => Math.ceil(Math.random() * 49))
          this.randomColor = this.randomNum.map(color => SeBoArray[Math.floor(Math.random() * 3)])
        }, 200)
      } else {
        clearInterval(this.randomTimer)
        this.randomTimer = null
      }
    }
  },
  mounted() {
    this.getCpsDetail()
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    setBallColor(code) {
      return { [formatSeBo[code]]: true }
    },
    // 取得彩種資訊
    async getCpsDetail(cpCode) {
      this.$store.dispatch('lottery/getCpsDetail', cpCode).then((val) => {
        if (val) {
          this.isLoading = false
        }
      })
    },
    openVideo() {
      this.showVideo = true
    },
    formatWeek(weekArray) {
      return weekArray.length === 7 ? '每日' : weekArray.map(day => weekMap[day]).join('')
    },
    formatMinute(intervalSeconds) {
      return Math.floor(intervalSeconds / 60) + '分'
    },
    padZero(num) {
      return String(num).padStart(2, '0')
    },
    toggleCalendar() {
      const popover = this.$refs.calendarPopover
      if (popover) {
        popover.referenceElm = this.$refs.calendarBtn
      }
      this.showCalendar = !this.showCalendar
    },
    handleOutsideClick(e) {
      if (!this.showCalendar) return
      const popover = this.$refs.calendarPopover
      const btn = this.$refs.calendarBtn
      const popperEl = popover && popover.popper
      if (btn && btn.contains(e.target)) return
      if (popperEl && popperEl.contains(e.target)) return
      this.showCalendar = false
    },
    // 格式化休市
    formatClose(val) {
      const strFirst = val.split('\n').map(item => item.split(' ~ ').map(date => date.replace(/^\d{4}\-/, '').replace('-', '/')))
      // 當天日期不顯示區間
      const strNoRepeat = strFirst.map(item => item[0] === item[1] ? [item[0]] : item).map(item => item.join('~'))
      return strNoRepeat.join(' , ')
    }
  }
}
</script>

<style lang="scss" scoped>
.date {
  margin-bottom: 8px;
  .button-outline__text::after {
    content: '';
    background: url('~assets/style/desktop/img/date.png') no-repeat center;
    background-size: contain;
    display: inline-block;
    position: relative;
    left: 4px;
    top: calc(50% - .4375rem);
    width: 16px;
    height: 12px;
  }
  .button-outline:hover .button-outline__text::after {
    background: url('~assets/style/desktop/img/date-p.png') no-repeat center;
    background-size: contain;
  }
  .button-outline.active .button-outline__text::after {
    background: url('~assets/style/desktop/img/date-w.png') no-repeat center;
    background-size: contain;
  }
}
.button-outline {
  &:hover {
    cursor: pointer;
  }
}

.lottery-title__explanation {
  display: flex;
  flex-direction: column;
  margin: 0 12px;

  a.button-outline {
    justify-content: center;
  }
}

</style>
